<!-- Breadcrumb Start -->
<div class="breadcrumb-wrap d-none d-md-block">
  <div class="container-fluid">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/']" [title]="'common.home' | translate">{{ "common.home" | translate }}</a>
      </li>
      <li class="breadcrumb-item">
        <a [routerLink]="['/products', 'all']">{{ "common.products" | translate }}</a>
      </li>
      <li class="breadcrumb-item active">{{ "product.details" | translate }}</li>
    </ul>
  </div>
</div>
<!-- Breadcrumb End -->

<!-- Product Detail Start -->
<div class="product-detail">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="product-detail-top">
          <div class="row p-4">

            <!-- ===================== REDESIGNED SLIDER ===================== -->
            <div class="col-md-5 product-gallery" style="z-index: 0">

              <!-- Single image fallback (no mediaList) -->
              <ng-container *ngIf="mediaList.length === 0 && offer != null">
                <div class="gallery-main-wrap">
                  <div class="gallery-badges">
                    <span class="gallery-badge gallery-badge--stock" *ngIf="offer.qty > 0 && !offer.availableDate">
                      <i class="fa fa-check"></i> {{ "product.in_stock" | translate }}
                    </span>
                    <span class="gallery-badge gallery-badge--promo" *ngIf="offer.pricing.nicename === 'promotion'">
                      {{ "product.on_sale" | translate }}
                    </span>
                  </div>
                  <img [alt]="usingFrench ? offer.product.productNameFr : offer.product.name" class="gallery-main-img"
                    [src]="printImage(offer.product)" />
                </div>
              </ng-container>

              <!-- Full slider (with mediaList) -->
              <ng-container *ngIf="mediaList.length > 0">
                <div class="gallery-main-wrap" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">

                  <!-- Badges -->
                  <div class="gallery-badges">
                    <span class="gallery-badge gallery-badge--stock"
                      *ngIf="offer != null && offer.qty > 0 && !offer.availableDate">
                      <i class="fa fa-check"></i> {{ "product.in_stock" | translate }}
                    </span>
                    <span class="gallery-badge gallery-badge--promo"
                      *ngIf="offer != null && offer.pricing.nicename === 'promotion'">
                      {{ "product.on_sale" | translate }}
                    </span>
                  </div>

                  <!-- Main image -->
                  <img class="gallery-main-img" [class.gallery-main-img--zooming]="isZoomed"
                    [src]="getImageSrc(mediaList[activeSlide]?.path)" [alt]="'product.image' | translate"
                    (mouseenter)="isZoomed = true" (mouseleave)="isZoomed = false" />

                  <!-- Prev / Next arrows -->
                  <button class="gallery-nav gallery-nav--prev" (click)="prevSlide()" type="button"
                    aria-label="Previous image">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                      stroke-linejoin="round">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                  </button>
                  <button class="gallery-nav gallery-nav--next" (click)="nextSlide()" type="button"
                    aria-label="Next image">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                      stroke-linejoin="round">
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  </button>

                  <!-- Dot indicators -->
                  <div class="gallery-dots" *ngIf="mediaList.length > 1">
                    <span *ngFor="let media of mediaList; let i = index" class="gallery-dot"
                      [class.gallery-dot--active]="i === activeSlide" (click)="goToSlide(i)"></span>
                  </div>

                  <!-- Image counter -->
                  <div class="gallery-counter">{{ activeSlide + 1 }} / {{ mediaList.length }}</div>
                </div>

                <!-- Thumbnail strip -->
                <div class="gallery-thumbs" *ngIf="mediaList.length > 1">
                  <div *ngFor="let media of mediaList; let i = index" class="gallery-thumb"
                    [class.gallery-thumb--active]="i === activeSlide" (click)="goToSlide(i)">
                    <img [src]="getImageSrc(media.path)" [alt]="'product.image' | translate" />
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- ==================== END REDESIGNED SLIDER =================== -->

            <div class="col-md-7" *ngIf="this.offer != null">
              <div class="product-content">
                <div class="mb-0">
                  <div class="instock mb-1" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">
                    <i class="fa fa-check"></i>
                    {{ "product.in_stock" | translate }}
                  </div>
                  <ng-template #outOfStock>
                    <div class="outofstock mb-1">
                      <i class="fa fa-xmark"></i>
                      {{ "product.out_of_stock" | translate }}
                    </div>
                  </ng-template>
                </div>
                <div class="title" style="display: inline-grid; height: 40px;">
                  <h1>{{ usingFrench ? offer.product.productNameFr : offer.product.name }}</h1>
                </div>
                <div class="d-lg-flex align-items-center mt-2 mb-3 basic-info d-none">
                  <div class="d-flex align-items-center">
                    <ngb-rating *ngIf="(reviews | json) != ({} | json)" [max]="5" [(rate)]="reviews.avgStars"
                      [readonly]="true"></ngb-rating>
                    <span class="rating-value ms-2">({{ reviews.avgStars }})</span>
                  </div>
                  <div class="sep mx-2"><i class="fa fa-circle"></i></div>
                  <div class="d-flex align-items-center">
                    <div><i class="far fa-comments"></i></div>
                    <div class="review ms-2 text-capitalize">{{ reviews.nbReviews }} {{ "common.reviews" | translate }}
                    </div>
                  </div>
                </div>
                <div class="price-summary">
                  <p>
                    <span class="price">{{ getOfferPrice(offer) }}</span>
                    {{ offer.currency | uppercase }} / {{ usingFrench ? offer.measurementunit.descriptionFr :
                    offer.measurementunit.description }}
                    <br>
                    <span style="font-size: 14px; color: #e44934;" *ngIf="offer.pricing.nicename === 'promotion'">
                      <s>{{ getDiscountPrice(offer) }} {{ offer.currency | uppercase }}</s>
                    </span>
                  </p>
                </div>
                <div class="quantity" *ngIf="showQty">
                  <h5>Qty:</h5>
                  <div class="qty">
                    <button type="button" class="btn-minus" (click)="decrementQty(offer)">
                      <i class="fa fa-minus"></i>
                    </button>
                    <input type="text" title="Qty" (change)="changeQty($event, offer, products)"
                      [value]="getCurrentQty(offer, products | async)" maxlength="12" id="qty" name="qty" />
                    <button class="btn-plus" type="button" (click)="incrementQty(offer)">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="border-top border-bottom px-0 py-2">
                  <div class="ps-1">
                    <div class="d-flex product_attr align-items-center">
                      <p class="attr_name">{{ "common.category" | translate }}:</p>
                      <p class="attr_text">{{ usingFrench ? offer.product.category.nameFr : offer.product.category.name
                        }}</p>
                    </div>
                    <div class="d-flex product_attr align-items-center">
                      <p class="attr_name">{{'product.condition' | translate}}</p>
                      <p class="attr_text">{{ usingFrench ? offer.productCondition.descriptionFr :
                        offer.productCondition.description }}</p>
                    </div>
                    <div class="d-flex product_attr align-items-center">
                      <p class="attr_name">{{'product.offer_returns.label' | translate}}</p>
                      <p class="attr_text" *ngIf="offer.returns == 1; else not_accepted">
                        {{'product.offer_returns.accepted' | translate }}
                      </p>
                      <ng-template #not_accepted>
                        <p class="attr_text">{{'product.offer_returns.not_accepted' | translate }}</p>
                      </ng-template>
                    </div>
                    <div class="d-flex product_attr align-items-center" *ngIf="offer.availableDate">
                      <p class="attr_name">Available from</p>
                      <p class="attr_text">{{ offer.availableDate | date:'mediumDate' }}</p>
                    </div>
                  </div>
                </div>
                <div class="border-bottom px-0 py-2">
                  <div class="ps-1">
                    <div class="d-flex product_attr shop_info align-items-center">
                      <p class="attr_name">{{ "common.seller" | translate }}:</p>
                      <p class="attr_text">{{ getSellerName(offer.user) | titlecase }}</p>
                    </div>
                    <div class="d-flex product_attr shop_info align-items-center" *ngIf="offer.user?.id">
                      <p class="attr_name">More:</p>
                      <p class="attr_text">
                        <a [routerLink]="['/products/seller', offer.user.id]" class="seller-products-link">
                          View all products from this seller <i class="fa fa-arrow-right ms-1"></i>
                        </a>
                      </p>
                    </div>
                    <div class="d-flex product_attr shop_info align-items-center">
                      <p class="attr_name">{{ "common.address" | translate }}:</p>
                      <p class="attr_text mb-3" *ngIf="offer.user.country != null">
                        {{ offer.user.town | titlecase }}, {{ offer.user.country.nicename | titlecase }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="action mt-4 mb-5 d-flex flex-wrap gap-2">
<button class="btn btn-primary text-white fw-semibold rounded-1 shadow-sm btn-md px-4 py-2"
                    *ngIf="!productModel" [disabled]="!(offer.qty > 0 && !offer.availableDate)" (click)="addProductToCart(offer)"
                    title="Add to Cart" type="button">
                    <i class="fa fa-shopping-cart me-2"></i>{{ "common.add_to_cart" | translate }}
                  </button>
                  <button class="btn btn-success text-white fw-semibold rounded-1 shadow-sm btn-md px-4 py-2"
                    *ngIf="!productModel" [disabled]="!(offer.qty > 0 && !offer.availableDate)" (click)="buyNow(offer)" title="Buy Now"
                    type="button">
                    <i class="fa fa-shopping-bag me-2"></i>{{ "common.buy_now" | translate }}
                  </button>
                  <button class="btn btn-outline-primary fw-semibold rounded-1 shadow-sm btn-md px-3 py-2"
                    *ngIf="!isInWishlist" (click)="addToWishlist()" type="button">
                    <i class="far fa-heart me-2"></i>{{ "common.add_to_wishlist" | translate }}
                  </button>
                </div>

                <!-- Shipping Preview -->
                <div class="shipping-preview" *ngIf="offer">
                  <div class="shipping-preview-title">
                    {{ 'product.shipping_options' | translate }}
                  </div>
                  <div class="shipping-preview-items">
                    <div class="shipping-preview-item" *ngFor="let option of offer.shippingOptions">
                      <i class="fa" [class.fa-truck]="option.shippingTypeRef === 'INTERCITY'"
                        [class.fa-plane]="option.shippingTypeRef === 'INTERNATIONAL'"></i>
                      <span>{{ getShippingTypeLabel(option.shippingTypeRef) }}</span>
                      <span class="shipping-preview-price">{{ getShippingStartingAtLabel(option) }}</span>
                    </div>
                    <div class="shipping-preview-item" *ngIf="offer.localPickup == 1">
                      <i class="fa fa-map-marker"></i>
                      <span>{{ 'product.local_pickup' | translate }}</span>
                      <span class="shipping-preview-price">{{ 'product.shipping_available' | translate }}</span>
                    </div>
                    <p class="shipping-preview-empty" *ngIf="!hasShippingOptions() && offer.localPickup != 1">
                      {{ 'product.shipping_no_options' | translate }}
                    </p>
                  </div>
                </div>

                <div class="mt-2">
                  <div class="d-flex align-items-center">
                    <p class="me-2 mb-0">Share:</p>
                    <div class="share-icons">
                      <a (click)="openShareWindow(facebookShareUrl, 'facebook')" class="btn btn-sm me-2 facebook"
                        role="button" tabindex="0">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                      <a (click)="openShareWindow(twitterShareUrl, 'twitter')" class="btn btn-sm me-2 twitter"
                        role="button" tabindex="0">
                        <i class="fab fa-twitter"></i>
                      </a>
                      <a (click)="openShareWindow(linkedinShareUrl, 'linkedin')" class="btn btn-sm me-2 linkedin"
                        role="button" tabindex="0">
                        <i class="fab fa-linkedin-in"></i>
                      </a>
                      <a (click)="openShareWindow(whatsappShareUrl, 'whatsapp')" class="btn btn-sm me-2 whatsapp"
                        role="button" tabindex="0">
                        <i class="fab fa-whatsapp"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row product-detail-bottom">
          <div class="col-lg-12" *ngIf="this.offer != null">
            <ul class="nav nav-tabs py-0 flex-column flex-sm-row" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link active" data-bs-toggle="pill" href="#description" role="tab">
                  {{ "product.description" | translate }}
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" data-bs-toggle="pill" href="#reviews" role="tab">
                  Reviews ({{ reviews.nbReviews }})
                </a>
              </li>
            </ul>

            <div class="tab-content" id="pills-tabContent">
              <div id="description" class="container tab-pane fade show active" role="tabpanel">
                <h4>Product description</h4>
                <p [innerHTML]="offer.description"></p>
              </div>
              <div id="reviews" class="container tab-pane fade" role="tabpanel">
                <div class="reviews-submitted" *ngIf="displayReviews?.length > 0">
                  <div *ngFor="let review of displayReviews">
                    <div class="reviewer">
                      {{ review?.fullName }} - <span>{{ review?.createdAt | date : "dd MMM yyyy" }}</span>
                    </div>
                    <p>{{ review?.remark }}</p>
                  </div>
                  <div *ngIf="showMoreButton">
                    <button (click)="showMore()">Show More</button>
                  </div>
                </div>
                <div class="reviews-submit">
                  <h4>Give your Review:</h4>
                  <form [formGroup]="reviewForm" (ngSubmit)="submitReviewForm()">
                    <ngb-rating [max]="5" [(rate)]="reviewStars" [readonly]="false" class="review"
                      formControlName="rating"></ngb-rating>
                    <div class="row form">
                      <div class="col-sm-12">
                        <textarea row="10" formControlName="review" placeholder="Drop a review"></textarea>
                      </div>
                      <div class="col-sm-12">
                        <button>Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Product Detail End -->

<!-- related products start -->
<app-related-products [relatedProducts]="relatedProducts" [loadingState]="relatedOffersLoading"></app-related-products>
<!-- related products end -->